<template>
  <v-container class="lx-page">
    <header class="lx-page-head">
      <span class="kicker">Research · White Paper</span>
      <h1>White Paper</h1>
      <h4>
        How the H2F2 hybrid forecasting technique works: the weekly dataset,
        the model search and selection, and how forecasts are validated out of
        sample.
      </h4>
    </header>
    <section class="lx-panel lx-paper">
      <div class="lx-panel__body d-flex align-center flex-wrap ga-4">
        <v-icon icon="mdi-file-pdf-box" size="36" class="lx-paper__icon"></v-icon>
        <div class="lx-paper__text">
          <span class="lx-panel__title">Janus4cast white paper</span>
          <span class="lx-panel__meta">PDF</span>
        </div>
        <span class="lx-toolbar__spacer"></span>
        <a class="lx-btn" :href="getFile" target="_blank" rel="noopener" download>
          <v-icon icon="mdi-download" size="16" class="mr-1"></v-icon>Download
        </a>
      </div>
    </section>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
export default {
  name: "white-paper",
  components: {},
  data() {
    return {
      value: "",
    };
  },
  methods: {
    ...mapActions(["getWhitePaper"]),
  },
  computed: {
    ...mapGetters(["getFile"]),
  },
  created() {
    console.log("White Paper");
  },
  mounted() {
    this.getWhitePaper();
  },
};
</script>
<style scoped>
table thead tr th {
  font-family: var(--f-body);
  color: var(--text);
  font-weight: bold;
  font-size: 16px !important;
}
table tbody tr td {
  font-family: var(--f-body);
  color: var(--text);
  font-weight: bold;
}
v-input__details {
  margin: 0%;
}
</style>